import { DocumentPart } from "../../api/models";
import { store } from "../../redux/store/store";
import { setDocumentToDownload } from "../../redux/feature/document/download-document-slice";
import { navigate } from "../../redux/feature/general/navigation-slice";
import { DOWNLOAD_COPY } from "../../utils/constants/navigation";
import * as React from "react";
import { downloadDocumentCopyAsync } from "../../redux/feature/document/document-slice";

export function DownloadDocumentButton({ document }: { document: DocumentPart }) {
  async function onClick() {
    if (!document.hasChildren) {
      const payload = {
        documentId: document.id,
        text: document.name,
        hasChildren: false,
        expanded: true,
        checked: true,
        items: [],
        disabled: false,
      };
      await downloadDocumentCopyAsync(payload);
      return;
    }

    store.dispatch(
      setDocumentToDownload({
        document: {
          text: document.name,
          hasChildren: document.hasChildren,
          checked: true,
          hasReadPermissions: true,
          key: document.id,
          expanded: true,
          items: [],
          selected: false,
          nodeType: "root",
          driveItemId: document.driveItemId,
          order: 0,
          data: null,
        },
      })
    );
    store.dispatch(navigate(DOWNLOAD_COPY));
  }

  return (
    <button
      id={`${document.name}_download`}
      style={{
        all: "unset",
        cursor: "pointer",
        padding: "2px",
        position: "absolute",
        right: "9px",
        top: "50%",
        transform: "translateY(-50%)",
      }}
      onClick={onClick}
    >
      <img src="/assets/download-icon.svg" alt="DownloadCopy" />
    </button>
  );
}
